export default "__VITE_ASSET__cfe2e060__"